import axios from "../utils/axios";

export const MeetingService = {
  createMeeting: async (formData) => {
    try {
      const response = await axios.post("/api/meeting/createMeeting", formData);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw response.data;
      }
    } catch (error) {
      throw (
        error?.response?.data || { message: "Failed to add create meeting" }
      );
    }
  },
  getMeeting: async (date) => {
    try {
      const response = await axios.get(`/api/meeting/getMeetings`, {
        params: date ? { date } : {},
      });
      if (response.data.success) {
        return response.data;
      } else {
        throw response.data;
      }
    } catch (error) {
      throw error?.response?.data || { message: "Failed to get meeting" };
    }
  },
  getMeetingById: async (id) => {
    try {
      const response = await axios.get(`/api/meeting/getMeetingById/${id}`);
      if (response.data.success) {
        return response.data;
      } else {
        throw response.data;
      }
    } catch (error) {
      throw error?.response?.data || { message: "Failed to get meeting" };
    }
  },
  getEligibleEmployees: async () => {
    try {
      const response = await axios.get("/api/meeting/getEligibleEmployees");

      if (response.data.success) {
        return response.data.data;
      } else {
        throw response.data;
      }
    } catch (error) {
      throw (
        error?.response?.data || {
          message: "Failed to fetch eligible employees",
        }
      );
    }
  },
  addParticipants: async (meetingId, participants) => {
    try {
      const response = await axios.post(
        `/api/meeting/addParticipants/${meetingId}`,
        {
          participants,
        }
      );
      if (response.data.success) {
        return response.data;
      } else {
        throw response.data;
      }
    } catch (error) {
      throw error?.response?.data || { message: "Failed to add participants" };
    }
  },
  getParticipants: async (meetingId) => {
        try {
            const response = await axios.get(`/api/meeting/getParticipants/${meetingId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: "Failed to fetch participants" };
        }
    },  
  editMeeting: async (id, editForm) => {
    try {
      const response = await axios.put(
        `/api/meeting/editMeeting/${id}`,
        editForm
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || { message: "Failed to update meeting" };
    }
  },
  deleteMeeting: async (meetingId) => {
    try {
      const response = await axios.delete(
        `/api/meeting/deleteMeeting/${meetingId}`
      );
      if (response.data.success) {
        return response.data;
      } else {
        throw response.data;
      }
    } catch (error) {
      throw error?.response?.data || { message: "Failed to delete meeting" };
    }
  },
  getTodaysMeetingCount: async () => {
    try {
      const response = await axios.get("/api/counts/getTodaysMeetingCount");
      return response.data;
    } catch (error) {
      throw (
        error?.response?.data || {
          message: "Failed to get today's meeting count",
        }
      );
    }
  },
  removeParticipant: async (meetingId, participantId) => {
    try {
      const response = await axios.delete(
        `/api/meeting/removeParticipant/${meetingId}/${participantId}`
      );
      if (response.data.success) {
        return response.data;
      } else {
        throw response.data;
      }
    } catch (error) {
      throw (
        error?.response?.data || { message: "Failed to remove participant" }
      );
    }
  },
};
